import i18n from './config';

export default i18n;
